/**
 * Company Authentication Layout
 * Handles switching between company login and register views
 */

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CompanyLogin from './CompanyLogin';
import CompanyRegister from './CompanyRegister';

/**
 * Company Auth Layout component
 * 
 * @returns {JSX.Element} Company auth layout
 */
const CompanyAuthLayout = () => {
  const location = useLocation();
  const [showLogin, setShowLogin] = useState(true);

  // Check URL state for initial view
  useEffect(() => {
    const state = location.state;
    if (state && typeof state.showLogin === 'boolean') {
      setShowLogin(state.showLogin);
    }
  }, [location.state]);

  const switchToLogin = () => setShowLogin(true);
  const switchToRegister = () => setShowLogin(false);

  return (
    <>
      {showLogin ? (
        <CompanyLogin switchToRegister={switchToRegister} />
      ) : (
        <CompanyRegister switchToLogin={switchToLogin} />
      )}
    </>
  );
};

export default CompanyAuthLayout;